import { defineComponent as _defineComponent } from 'vue'
import GBaseModal from '@/components/g-base-modal.vue'
import MConflictTable from '@/views/newPaiban/component/m-conflict-table.vue'
import { computed, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'm-paiban-task-conflict-modal',
  props: {
    visible: { type: Boolean, default: false },
    data: { default: null },
    productionLineName: { default: '' },
    isOkLoading: { type: Boolean, default: false }
  },
  emits: ["ok", "cancel"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'ok'): void
  (e: 'cancel'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { visible: boolean, data: Record<string, unknown> | null, productionLineName: string, isOkLoading: boolean }





const isDetail = ref(false)

const conflictModalWidth = computed(() => (isDetail.value ? 760 : 520))

function resetDetail(): void {
  isDetail.value = false
}

function handleCancel(): void {
  resetDetail()
  emit('cancel')
}

function handleOk(): void {
  resetDetail()
  emit('ok')
}

watch(
  () => props.visible,
  (val) => {
    if (!val) {
      resetDetail()
    }
  }
)

return { __sfc: true,emit, props, isDetail, conflictModalWidth, resetDetail, handleCancel, handleOk, GBaseModal, MConflictTable }
}

})